import React from 'react';

const HomePage = () => (
  <>
    <h1>
      {'Componentes dos fundos ETF XP Asset Management'}
    </h1>
  </>
);

export default HomePage;
